import PropTypes from 'prop-types';
import str from 'underscore.string';
import moment from 'moment';
import EmptyStateMessage from 'components/lists/empty-state-message';
import EnrichmentConfidencePill from './enrichment-confidence-pill';

const NoteworthyEventsTable = ({ events }) => {
  if (!events || events.length === 0) {
    return <EmptyStateMessage hideIcon text="No enriched event data available" />;
  }

  // Sort by recorded_at or updated_at (most recent first) and limit to 3
  const sortedEvents = [...events]
    .sort((a, b) => {
      const dateA = a.recorded_at || a.updated_at;
      const dateB = b.recorded_at || b.updated_at;
      return moment(dateB) - moment(dateA);
    })
    .slice(0, 3);

  return (
    <div className="noteworthy-events-table">
      <table className="noteworthy-events-table--table">
        <thead>
          <tr>
            <th className="noteworthy-events-table--th">Event</th>
            <th className="noteworthy-events-table--th">Date Reported</th>
            <th className="noteworthy-events-table--th">Confidence</th>
          </tr>
        </thead>
        <tbody>
          {sortedEvents.map((event) => {
            const displayDate = event.recorded_at || event.updated_at;
            return (
              <tr key={event.id} className="noteworthy-events-table--row">
                <td className="noteworthy-events-table--td">{str.capitalize(event.type)}</td>
                <td className="noteworthy-events-table--td">{moment(displayDate).format('MM/DD/YY')}</td>
                <td className="noteworthy-events-table--td">
                  {event.confidence_score ? (
                    <EnrichmentConfidencePill score={event.confidence_score} />
                  ) : (
                    <span className="noteworthy-events-table--dash">-</span>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

NoteworthyEventsTable.propTypes = {
  events: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      type: PropTypes.string.isRequired,
      recorded_at: PropTypes.string.isRequired,
      confidence_score: PropTypes.number,
      source: PropTypes.string,
    })
  ),
};

export default NoteworthyEventsTable;
